import { getElementChildren, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'
import { IS_HIDDEN } from '../../../../Resources/Private/TypeScript/Utility/State'

class FooterNavigation {
  private linkExpandButtons: NodeListOf<HTMLElement>
  private listExpandButtons: NodeListOf<HTMLElement>

  constructor() {
    this.linkExpandButtons = getElements('footer-nav-link-expand-button')
    this.listExpandButtons = getElements('footer-nav-list-expand-button')
  }

  init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.linkExpandButtons.forEach((button): void => {
      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', (!isExpanded).toString())
      })
    })

    this.listExpandButtons.forEach((button): void => {
      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        const listSelector = button.getAttribute('aria-controls')

        button.setAttribute('aria-expanded', (!isExpanded).toString())

        if (listSelector) {
          const list = document.querySelector('#' + listSelector)

          if (list) {
            const navItems = getElementChildren(list as HTMLElement, 'footer-nav-item')

            navItems.forEach((navItem) => {
              const isHidden = navItem.classList.contains(IS_HIDDEN)

              if (isHidden) {
                navItem.classList.remove(IS_HIDDEN)
              } else {
                navItem.classList.add(IS_HIDDEN)
              }
            })
          }
        }
      })
    })
  }
}

const footerNavigation = new FooterNavigation()
footerNavigation.init()
